import SizeTracker from 'components/SizeTracker/SizeTracker';
import AboutPage from 'pages/AboutPage/AboutPage';
import ArticlePage from 'pages/ArticlePage/ArticlePage';
import BecomePartnersPage from 'pages/BecomePartnersPage/BecomePartnersPage';
import ContactPage from 'pages/ContactPage/ContactPage';
import DesignatedLeagues from 'pages/DesignatedLeagues/DesignatedLeagues';
import EventsPage from 'pages/EventsPage/EventsPage';
import FaqPage from 'pages/FaqPage/FaqPage';
import FinalsPage from 'pages/FinalsPage/FinalsPage';
import GalleryPage from 'pages/GalleryPage/GalleryPage';
import GlobalRegistrationPage from 'pages/GlobalRegistrationPage/GlobalRegistrationPage';
import HistoryPage from 'pages/HistoryPage/HistoryPage';
import HomePage from 'pages/HomePage/HomePage';
import PartnersPage from 'pages/PartnersPage/PartnersPage';
import RulesPage from 'pages/RulesPage/RulesPage';
import ScoresPage from 'pages/ScoresPage/ScoresPage';
import Tournaments from 'pages/Tournaments/Tournaments';
import * as React from 'react';
import * as ga from 'react-ga';
import { NotificationContainer } from 'react-notifications';
import { Route, RouteComponentProps, Switch, withRouter } from 'react-router';
import DefaultPage from 'wrappers/DefaultPage/DefaultPage';

type Props = RouteComponentProps;

class App extends React.Component<Props> {
  public componentDidUpdate(prevProps: Props) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      console.log('logging');
      ga.pageview(this.props.location.pathname);
    }
  }
  public render() {
    const DefaultComponent = () => (
      <DefaultPage>
        <Switch>
          <Route path="/" exact={true} component={HomePage} />
          <Route path="/about" exact={true} component={AboutPage} />
          <Route path="/history" exact={true} component={HistoryPage} />
          <Route path="/gallery" exact={true} component={GalleryPage} />
          <Route path="/faq" exact={true} component={FaqPage} />
          <Route path="/rules" exact={true} component={RulesPage} />
          <Route path="/contact" exact={true} component={ContactPage} />
          <Route path="/partners" exact={true} component={PartnersPage} />
          <Route path="/events" exact={true} component={EventsPage} />
          <Route path="/article/:id" exact={true} component={ArticlePage} />
          <Route path="/register" component={GlobalRegistrationPage} />
          <Route path="/world-finals" component={FinalsPage} />
          <Route
            path="/become-partner"
            exact={true}
            component={BecomePartnersPage}
          />
          <Route path="/tournaments" exact={true} component={Tournaments} />
          <Route path="/scores" exact={true} component={ScoresPage} />
          <Route path="/designatedleagues" component={DesignatedLeagues} />
        </Switch>
      </DefaultPage>
    );
    return (
      <React.Fragment>
        <Route path="" component={DefaultComponent} />
        <SizeTracker />
        <NotificationContainer />
      </React.Fragment>
    );
  }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/App.tsx